import { FormMultilineTextField, FormTextField } from '@fs/zion-form'
import React from 'react'
import { useTranslation } from 'react-i18next'

const MAX_NAME_CHARS = 100
const MAX_DESCRIPTION_CHARS = 1000
const MAX_RULES_CHARS = 1000

export default function GroupDetailsForm() {
  const [t] = useTranslation()
  return (
    <>
      <FormTextField
        name="groupName"
        data-testid="create-edit-group.group-name.field"
        maxLength={MAX_NAME_CHARS}
        label={t('create-edit-group.label.group-name')}
      />

      <FormMultilineTextField
        name="groupDescription"
        data-testid="create-edit-group.group-description.field"
        disableResize
        maxLength={MAX_DESCRIPTION_CHARS}
        label={t('create-edit-group.label.group-description')}
      />

      <FormMultilineTextField
        name="groupRules"
        data-testid="create-edit-group.group-rules.field"
        disableResize
        maxLength={MAX_RULES_CHARS}
        label={t('create-edit-group.label.group-rules')}
        rows={2}
      />
    </>
  )
}
